import { render } from "./InviteJudgeModal.vue?vue&type=template&id=13df3c75&scoped=true"
import script from "./InviteJudgeModal.vue?vue&type=script&lang=js"
export * from "./InviteJudgeModal.vue?vue&type=script&lang=js"

import "./InviteJudgeModal.vue?vue&type=style&index=0&id=13df3c75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13df3c75"]])

export default __exports__